export enum ResponseCodes {
    HE000050 = 'HE000050',
    HS000000 = 'HS000000',
    HE200001 = 'HE200001',
    HE200002 = 'HE200002',
    HE200003 = 'HE200003',
    HE200029 = 'HE200029',
    HE200030 = 'HE200030',
    HE200031 = 'HE200031',
    HE200038 = 'HE200038',
    HE200039 = 'HE200039',
    HE200013 = 'HE200013',
    HE200037 = 'HE200037',
    HE200014 = 'HE200014',
    HE200015 = 'HE200015',
    HE200024 = 'HE200024',
    HE200025 = 'HE200025',
    HE200026 = 'HE200026',
    HE200027 = 'HE200027',
    HE200016 = 'HE200016',
    HE200040 = 'HE200040',
    HE200018 = 'HE200018',
    HE200041 = 'HE200041',
    HE200006 = 'HE200006',
    HE200045 = 'HE200045',
    HE200004 = 'HE200004',
    HE200005 = 'HE200005',
    HE200008 = 'HE200008',
    HE200009 = 'HE200009',
    HE200010 = 'HE200010',
    HE200020 = 'HE200020',
}

export enum FinalDecisionCodes {
    ERROR = 'ERROR',
    CONTINUE = 'CONTINUE',
    STOP = 'STOP',
    INVESTIGAT = 'INVESTIGAT',
    NODECISION = 'NODECISION',
    RF1 = 'RF1',
    RF2 = 'RF2',
    RF3 = 'RF3',
    RF4 = 'RF4',
    ACC = 'ACC'
}